module.exports = __webpack_public_path__ + "img/sixpackcarrier49.8b8bc0d4.jpg";